import React from 'react';

import { AuthorizeUserTree, permissions, permissionTypes } from '../../shared/authorization';
import { useBatchRefreshTaxBookingEntities } from '../../shared/mutations/taxBookingEntities';
import { RefreshEntityNavigationButton } from '../../shared/refreshEntityNavigationButton.component';

const requiredPermissions = [{
  permissionType: permissionTypes.MODIFY,
  permissionPath: permissions.TAX_BOOKING_ENTITIES,
}];

export const RefreshTaxBookingEntitiesNavigationButton: {} = () => {
  const {
    mutate: refreshTaxBookingEntities,
    isLoading: isRefreshingTaxBookingEntities,
  } = useBatchRefreshTaxBookingEntities();

  return (
    <AuthorizeUserTree
      withPermissions={requiredPermissions}
    >
      <RefreshEntityNavigationButton
        buttonLabel="Refresh TBE"
        refreshEntity={refreshTaxBookingEntities}
        isRefreshingEntity={isRefreshingTaxBookingEntities}
      />
    </AuthorizeUserTree>
  );
};
